import { render, staticRenderFns } from "./TransactionMovedToaster.vue?vue&type=template&id=6ca8d809&scoped=true"
import script from "./TransactionMovedToaster.vue?vue&type=script&lang=js"
export * from "./TransactionMovedToaster.vue?vue&type=script&lang=js"
import style0 from "./TransactionMovedToaster.vue?vue&type=style&index=0&id=6ca8d809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca8d809",
  null
  
)

export default component.exports